import styled, { css } from "styled-components";
import convertHexToRgba from "~/helpers/convertHexToRgba";

export default styled.button.attrs({
  className: "btn",
})`
  ${({ theme, $fixed, $hide, $loading, $small, secondary, buttonConfig, featured }) => {
    const { media, colors } = theme;

    const {
      backgroundColor = secondary ? "white" : "red",
      borderColor = secondary ? "darkBlue" : "red",
      textColor = secondary ? "darkBlue" : "white",
      hoverBackgroundColor = "white",
      hoverBorderColor = secondary ? "darkBlue" : "red",
      hoverTextColor = secondary ? "darkBlue" : "red",
      activeTextColor = secondary ? "darkBlue" : "red",
      activeBackgroundColor = "white",
      activeBorderColor = secondary ? "darkBlue" : "red",
    } = buttonConfig || {};

    const parseBackgroundColor = featured ? buttonConfig?.featuredBackgroundColor : buttonConfig?.backgroundColor;
    const parseBorderColor = featured ? buttonConfig?.featuredBorderColor : buttonConfig?.borderColor;
    const parseTextColor = featured ? buttonConfig?.featuredTextColor : buttonConfig?.textColor;

    return css`
      background-color: ${colors.primary[parseBackgroundColor] || colors.primary[backgroundColor]};
      border: 1px solid ${colors.primary[parseBorderColor] || colors.primary[borderColor]};
      color: ${colors.primary[parseTextColor] || colors.primary[textColor]};
      cursor: pointer;
      display: inline-block;
      font-weight: 700;
      font-size: 1rem;
      height: ${$small ? "40px" : "auto"};
      text-decoration: none;
      text-transform: none;
      margin: 0;
      border-radius: 32px;
      padding: ${$small ? "0 24px" : "14px"};
      width: ${$small ? "160px" : "255px"};
      transition: background-color 0.2s, color 0.2s;

      &:disabled {
        background-color: ${convertHexToRgba(colors.primary[backgroundColor], 0.5)};
        border-color: transparent;
        color: ${colors.primary.white};
        cursor: no-drop;

        &:hover {
          background-color: ${convertHexToRgba(colors.primary[backgroundColor], 0.5)};
          color: ${colors.primary.white};
        }
      }

      ${!$loading &&
      css`
        &:hover {
          background-color: ${colors.primary[hoverBackgroundColor]};
          border: 1px solid ${colors.primary[hoverBorderColor]};
          color: ${colors.primary[hoverTextColor]};
          text-decoration: underline;
        }
      `}

      &.active {
        background-color: ${colors.primary[activeBackgroundColor]};
        border: 1px solid ${colors.primary[activeBorderColor]};
        color: ${colors.primary[activeTextColor]};
        text-decoration: none;
      }

      &.icon span {
        display: flex;
        justify-content: center;
        align-items: center;
        white-space: nowrap;

        svg {
          width: 1.125rem;
          margin-right: 0.5rem;
          transform: translateY(-2px);
        }
      }

      ${$hide &&
      css`
        display: none !important;
      `}

      ${$loading &&
      css`
        cursor: not-allowed;
        align-items: center;
        display: flex;
        justify-content: center;
      `}

      ${media.mobile.down} {
        ${!$fixed &&
        css`
          width: 100%;
          max-width: 100%;
        `}
      }
    `;
  }};
`;
